var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-consult-wrapper" },
    [
      _vm.isTelConsult
        ? [
            _c(
              "yxt-button",
              _vm._b(
                {
                  class: [
                    "consult-btn",
                    "consult-btn-tel",
                    _vm.size,
                    { active: _vm.active },
                  ],
                  attrs: { type: _vm.btnType, round: "", size: _vm.size },
                  on: { click: _vm.showTelPopup },
                },
                "yxt-button",
                _vm.$attrs,
                false
              ),
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("pc_biz_btn_phoneCall") /** 电话咨询 */) +
                    "\n    "
                ),
              ]
            ),
            _c(
              "yxt-dialog",
              {
                attrs: {
                  visible: _vm.telVisible,
                  title: _vm.$t("pc_biz_lbl_tel") /** 咨询电话 */,
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.telVisible = $event
                  },
                },
              },
              [
                _c("div", { staticClass: "tel-section" }, [
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.$t("pc_biz_lbl_tel") /** 咨询电话 */) +
                        "：" +
                        _vm._s(_vm.phone)
                    ),
                  ]),
                ]),
              ]
            ),
          ]
        : [
            _c(
              "yxt-button",
              _vm._b(
                {
                  class: _vm.isNoCustom
                    ? ""
                    : ["consult-btn", _vm.size, { active: _vm.active }],
                  attrs: {
                    size: _vm.size,
                    type: _vm.btnType,
                    round: _vm.isRound,
                  },
                  on: { click: _vm.handleConsult },
                },
                "yxt-button",
                _vm.$attrs,
                false
              ),
              [_vm._v("\n      " + _vm._s(_vm.consultBtnText) + "\n    ")]
            ),
            _c(
              "yxt-dialog",
              {
                staticClass: "qr-popup",
                attrs: {
                  title: _vm.$t("pc_biz_ttl_addFriend" /** 加好友 */),
                  closeable: "outer",
                  visible: _vm.visible,
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.visible = $event
                  },
                },
              },
              [
                _c("yxt-image", {
                  staticClass: "qr-image",
                  attrs: { radius: "8", src: _vm.qrCodeUrl },
                }),
                _c("div", { staticClass: "qr-tips" }, [
                  _c("div", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "pc_biz_tip_scanToConsult"
                        ) /** 扫码联系学习顾问咨询 */
                      )
                    ),
                  ]),
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.$t("pc_biz_lbl_tel") /** 咨询电话 */) +
                        "：" +
                        _vm._s(_vm.phone)
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }